<template>
	<div>
		<!-- <v-container align="center" justify="center" class="pa-5 pb-0">
			<ImageUploadAndCrop v-show="showCropper" :image="cropperImage" />
		</v-container> -->

		<v-container align="center" justify="center" class="pa-5 pb-0">
			<v-list-item three-line>
				<v-list-item-content>
					<v-list-item-title class="mb-1 text-center text-wrap"><h1>About the practice</h1></v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</v-container>

		<v-container class="pt-0 mt-0 mb-0">
			<v-form ref="practiceAboutForm" v-model="valid" class="pl-4 pr-5 pt-0">
				<v-card-text align="center" justify="center" class="justify-center text-center pb-0 pm-0">
					<v-row class="justify-center text-center pb-0 pm-0">
						<v-col>
							<input v-show="false" ref="logo" type="file" hide-details :prepend-icon="false" @input="handleAvatarImage($event.target.files[0])" />
							<v-avatar v-ripple class="justify-center text-center" :size="150" style="margin: auto" color="#F4F4F4">
								<v-img :src="logoPreview" alt="" contain :max-width="150" class="mx-auto"></v-img>
							</v-avatar>
						</v-col>
					</v-row>

					<v-row cols="12" class="justify-center text-center"
						><v-col style="text-transform: none !important"
							><v-btn id="logo" class="text-none" text @click="onClickAvatar($event.currentTarget.id)"
								><v-icon class="pr-2" color="primary">backup</v-icon> upload your logo</v-btn
							></v-col
						></v-row
					>

					<v-row class="justify-center text-center">
						<v-col class="error--text">
							<v-card-text v-show="avatarError">Please upload an logo of your practice</v-card-text>
						</v-col>
					</v-row>

					<v-row>
						<v-col>
							<v-textarea
								outlined
								:value="short_bio"
								:rules="shortBioRules"
								placeholder="Tell us more about your practice, your support team and your working environment."
								@change="changeBio"
							>
							</v-textarea>
						</v-col>
					</v-row>

					<v-row
						><v-col>
							<v-list-item-title align="center" justify="justify" class="pb-1 text-wrap"><h2>Upload pictures of your practice</h2></v-list-item-title>
						</v-col></v-row
					>

					<v-row>
						<v-col :cols="12" :lg="4">
							<input v-show="false" ref="imageA" type="file" hide-details :prepend-icon="false" @change="handleImage($event.target.files[0])" />
							<v-btn id="imageA" class="text-none" text @click="onClickAvatar($event.currentTarget.id)"
								><v-icon class="pr-2" color="primary">backup</v-icon> upload image A</v-btn
							>
							<v-card outlined flat height="138px">
								<v-img :src="imageToShow('imageA')" contain alt="" height="135px" />
							</v-card>
						</v-col>

						<v-col :cols="12" :lg="4">
							<input v-show="false" ref="imageB" type="file" hide-details :prepend-icon="false" @change="handleImage($event.target.files[0])" />
							<v-btn id="imageB" class="text-none" text @click="onClickAvatar($event.currentTarget.id)"
								><v-icon class="pr-2" color="primary">backup</v-icon> upload image B</v-btn
							>
							<v-card outlined flat height="138px">
								<v-img :src="imageToShow('imageB')" contain alt="" height="135px" />
							</v-card>
						</v-col>

						<v-col :cols="12" :lg="4">
							<input v-show="false" ref="imageC" type="file" hide-details :prepend-icon="false" @change="handleImage($event.target.files[0])" />
							<v-btn id="imageC" class="text-none" text @click="onClickAvatar($event.currentTarget.id)"
								><v-icon class="pr-2" color="primary">backup</v-icon> upload image C</v-btn
							>
							<v-card outlined flat height="138px">
								<v-img :src="imageToShow('imageC')" contain alt="" height="135px" />
							</v-card>
						</v-col>
					</v-row>
				</v-card-text>
			</v-form>
		</v-container>
	</div>
</template>

<script>
import { bus } from '@/main';
import axios from 'axios';
import store from '@/store';
// import ImageUploadAndCrop from '@/components/user/ImageUploadAndCrop.vue';

export default {
	data: () => ({
		dummyImage: require('@/assets/images/find-locum-bg.jpg'),
		valid: false,
		step: 'about-step',
		avatarError: false,
		short_bio: store.getters.company?.short_bio || '',
		shortBioRules: [v => !!v || 'Required', v => (!!v && v.length > 8) || 'Bio is too short.'],

		showCropper: false,
		cropperImage: null,

		// imageObj is populated with stored images on mount
		imageObj: {
			logo: null,
			imageA: null,
			imageB: null,
			imageC: null,
		},

		// imageUploads contains the images that have been uploaded by the user
		// in that particular session. Used for image preview and selective POSTs
		imageUploads: {
			logo: null,
			imageA: null,
			imageB: null,
			imageC: null,
		},
		idSelected: null,
	}),

	computed: {
		user() {
			return store.getters.user;
		},
		company() {
			return store.getters.company;
		},
		logoPreview() {
			return this.imageUploads.logo || this.imageObj.logo || require('@/assets/images/complete signup/orange/operations.svg');
		},
	},

	watch: {},

	async mounted() {
		bus.$emit('update:spinning', true);
		window.scrollTo(0, 0);
		bus.$on('intent:submit-forms:about-step', data => {
			this.postToBackend(data);
		});

		// called when the image is cropped successfully
		// bus.$on('image-cropped', blob => {
		// 	const reader = new FileReader();
		// 	reader.onload = event => {
		// 		this.cropperImage = null;
		// 		this.imageUploads[this.idSelected] = event.target.result;
		// 	};
		// 	reader.readAsDataURL(blob);
		// 	this.toggleCropper();
		// });

		// called when the image cropping is canceled
		// bus.$on('image-cropped-canceled', async () => {
		// 	this.toggleCropper();
		// 	this.cropperImage = null;
		// 	bus.$emit('update:spinning', true);
		// 	await this.getImages(this.imageUploads);
		// 	bus.$emit('update:spinning', false);
		// });

		await this.getImages(this.imageObj);

		bus.$emit('update:spinning', false);
	},

	beforeDestroy() {
		// bus.$off('image-cropped');
		// bus.$off('image-cropped-canceled');
	},

	methods: {
		// toggleCropper() {
		// 	this.showCropper = !this.showCropper;
		// },

		async getImages(imageObj) {
			try {
				const token = store.getters.jwtToken;
				let imageArr = store.getters.company?.documents?.images;
				const images = Object.keys(imageObj);

				for (let image of images) {
					if (imageArr?.includes(image)) {
						let res = await axios.get(store.getters.getDOCUMENTS + `/images/${image}/` + store.getters.company.id, { headers: { Authorization: token } });
						if (res.status === 200) {
							imageObj[image] = 'data:image/png;base64,' + res.data.data;
						}
					}
				}
			} catch (err) {
				console.error(err);
			}
		},

		imageToShow(image) {
			switch (image) {
				case 'imageA':
					return this.imageUploads.imageA || this.imageObj.imageA;
				case 'imageB':
					return this.imageUploads.imageB || this.imageObj.imageB;
				case 'imageC':
					return this.imageUploads.imageC || this.imageObj.imageC;
			}
		},

		handleAvatarImage(fileObject) {
			const reader = new FileReader();
			reader.onloadend = event => {
				// this.cropperImage = event.target.result;
				this.imageUploads[this.idSelected] = event.target.result;
				// this.toggleCropper();
			};
			reader.readAsDataURL(fileObject);
		},

		handleImage(fileObject) {
			const reader = new FileReader();
			reader.onloadend = event => {
				this.imageUploads[this.idSelected] = event.target.result;
			};
			reader.readAsDataURL(fileObject);
		},

		changeBio(newBio) {
			this.short_bio = newBio;
		},

		onClickAvatar(clickedId) {
			this.idSelected = clickedId;
			this.$refs[clickedId].click();
		},

		validate() {
			// if (!this.imageUploads.logo) {
			// 	this.avatarError = true;
			// 	return false;
			// }
			return this.$refs.practiceAboutForm.validate();
		},

		reset() {
			this.$refs.practiceAboutForm.reset();
		},

		resetValidation() {
			this.$refs.practiceAboutForm.resetValidation();
		},

		SubmitForm() {
			let valid = this.validate();
			if (valid) {
				bus.$emit('intent:submit-forms:' + this.name);
			}
		},

		checkStep() {
			const company = store.getters.company;
			const { short_bio, documents } = company;

			if (short_bio?.length > 0 && documents?.images?.logo) {
				store.commit('SET_PROFILE_BUTTON_TO_POSITIVE', this.step);
				return true;
			} else if (short_bio?.length > 0) {
				return true;
			} else {
				return false;
			}
		},

		async postToBackend() {
			//post to api backend for this form.
			let valid = this.validate();
			if (valid) {
				bus.$emit('update:spinning', true);
				try {
					const token = store.getters.jwtToken;
					const header = { headers: { Authorization: token } };
					const body = {
						short_bio: this.short_bio,
					};
					const practiceObjKeys = Object.keys(this.imageUploads);

					const company = store.getters.company;
					const logo = company.documents?.images.includes('logo') || this.imageUploads.logo;
					const short_bio = company.short_bio || body.short_bio;

					if (short_bio?.length > 0 && logo) {
						store.commit('SET_PROFILE_BUTTON_TO_POSITIVE', this.step);
					}

					let requests = [axios.put(store.getters.getAPI + '/companies/' + store.getters.company.id + '/about-company', body, header)];

					for (let image of practiceObjKeys) {
						if (this.imageUploads[image]) {
							requests.push(axios.post(store.getters.getDOCUMENTS + `/images/${image}/` + store.getters.company.id, { data: this.imageUploads[image] }, header));
						}
					}

					let responses = await axios.all(requests);

					bus.$emit('form-submitted', { form: this.name, status: responses.every(response => response.status == 200) });
					if (responses[0].status === 200) {
						store.commit('SET_COMPANY', responses[0].data.data); //refresh the companies state.
					}

					let i = 0;
					for (let image of practiceObjKeys) {
						if (this.imageUploads[image]) {
							i++;
							if (responses[i].status == 200 && !store.getters.company?.documents?.images?.includes(image)) {
								let response = await axios.put(store.getters.getAPI + '/companies/' + store.getters.company.id + '/documents/images', { doc: `${image}` }, header);
								await store.commit('SET_COMPANY', response.data.data); //refresh the companies state.
							}
						}
					}

					if (responses.every(response => response.status == 200)) {
						bus.$emit('update:spinning', false);
						bus.$emit('intent:next-step', 'about-step');
					} else {
						bus.$emit('update:spinning', false);
						window.scrollTo(0, 0);
					}
				} catch (err) {
					console.error(err);
				}
			}
		},

		beforeDestroy() {
			bus.$off('intent:submit-forms:about-step');
		},
	},
};
</script>
